import { protectedApi } from "../common/protectedApi";
import { APIS } from "../constants/apiConstant";

export const fetchActiveTimeTrackerSession = async () => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_ACTIVE,
    method: "GET",
  });
  return response?.data?.data?.session ?? null;
};

export const checkInTimeTracker = async () => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_CHECK_IN,
    method: "POST",
    data: {},
  });
  return response?.data?.data?.session ?? null;
};

export const checkOutTimeTracker = async ({ sessionId, autoCheckout = false } = {}) => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_CHECK_OUT,
    method: "POST",
    data: { sessionId, autoCheckout },
  });
  return response?.data?.data?.session ?? null;
};

export const recordTimeTrackerActivity = async (eventTypes = []) => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_ACTIVITY,
    method: "POST",
    data: { eventTypes },
  });
  return response?.data?.data?.session ?? null;
};

export const recordTimeTrackerVisibility = async (visible) => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_VISIBILITY,
    method: "POST",
    data: { visible },
  });
  return response?.data?.data?.session ?? null;
};

export const recordTimeTrackerIdleStart = async () => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_IDLE_START,
    method: "POST",
    data: {},
  });
  return response?.data?.data?.session ?? null;
};

export const recordTimeTrackerIdleAck = async () => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_IDLE_ACK,
    method: "POST",
    data: {},
  });
  return response?.data?.data?.session ?? null;
};

export const pauseTimeTracker = async () => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_PAUSE,
    method: "POST",
    data: {},
  });
  return response?.data?.data?.session ?? null;
};

export const resumeTimeTracker = async () => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_RESUME,
    method: "POST",
    data: {},
  });
  return response?.data?.data?.session ?? null;
};

export const fetchTimeTrackerHistory = async ({ from, to, limit = 50, offset = 0 } = {}) => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_HISTORY,
    method: "GET",
    params: { from, to, limit, offset },
  });
  return response?.data?.data?.sessions ?? [];
};

export const fetchTimeTrackerAdminStatus = async () => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_ADMIN_STATUS,
    method: "GET",
  });
  return response?.data?.data?.employees ?? [];
};

export const fetchTimeTrackerAdminHistory = async ({
  userId,
  from,
  to,
  limit = 100,
  offset = 0,
} = {}) => {
  const response = await protectedApi({
    url: APIS.TIME_TRACKER_ADMIN_HISTORY,
    method: "GET",
    params: { userId, from, to, limit, offset },
  });
  return response?.data?.data?.sessions ?? [];
};
